import { barLabelClasses } from '@mui/x-charts';
import { chartStyles } from '../common/common-chart-utils/common-chart-styles';

export const barChartStyles = () => {
  return {
    ...chartStyles(),
    [`.${barLabelClasses.root}`]: {
      fill: 'rgb(0,0,0)',
    },
    '& .MuiBarLabel-root': {
      fontSize: '12px',
    },
  };
};
